import { Account } from "./account";

export class AccountFamily {
    id: number;
    accountId: number;
    familyMemberId: number;
    familyMember: Account;
}


// WEBPACK FOOTER //
// ./src/model/accountFamily.ts